/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { cssMap, css, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Toggle from '@atlaskit/toggle/toggle';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const footerStyles = cssMap({
	default: {
		display: 'flex',
		paddingTop: token('space.075'),
		paddingLeft: token('space.075'),
		paddingRight: token('space.075'),
		paddingBottom: token('space.075'),
		gap: token('space.050'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		alignItems: 'center',
	},
});

const labelStyles = css({
	color: token('color.text.subtle'),
});

export function UsePageKnowledgeToggleFooter({
	onChange,
	isChecked,
}: {
	isChecked: boolean;
	onChange: () => void;
}): JSX.Element {
	const { formatMessage } = useIntl();
	const TOGGLE_ID = 'page-knowledge-toggle';

	return (
		<Box xcss={footerStyles.default} backgroundColor="elevation.surface">
			<Toggle id={TOGGLE_ID} testId={TOGGLE_ID} onChange={onChange} isChecked={isChecked} />
			<label htmlFor={TOGGLE_ID} css={labelStyles}>
				{formatMessage(messages.usePageKnowledgeToggleLabel)}
			</label>
		</Box>
	);
}
